import has from 'lodash/has';
import {
  GET_ROHSTOFFE,
  GET_ROHSTOFFBYID,
  CREATE_ROHSTOFF,
  CHECK_ROHSTOFFE,
  DELETE_ROHSTOFF,
  UPDATE_ROHSTOFF,
  GET_ROHSTOFFE_NAMES,
  CHECK_ROHSTOFF_REFERENCES,
  GET_ROHSTOFF_HISTORY,
  GET_ROHSTOFF_VERSION,
  RESTORE_ROHSTOFF_VERSION,
  COMPARE_ROHSTOFF_VERSIONS,
  RESET_ROHSTOFF_HISTORY,
} from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

export function rohstoffe(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_ROHSTOFFE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_ROHSTOFFE}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result')
          ? { ...action.result }
          : { rohstoffe: [], total_pages: 0 },
      };
    case `${GET_ROHSTOFFE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function rohstoffeNames(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_ROHSTOFFE_NAMES}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_ROHSTOFFE_NAMES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? [...action.result] : [],
      };
    case `${GET_ROHSTOFFE_NAMES}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function rohstoffeCheck(state = initialState, action = {}) {
  switch (action.type) {
    case `${CHECK_ROHSTOFFE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CHECK_ROHSTOFFE}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : '',
      };
    case `${CHECK_ROHSTOFFE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function rohstoffByID(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_ROHSTOFFBYID}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_ROHSTOFFBYID}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${GET_ROHSTOFFBYID}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function rohstoffCreate(state = initialState, action = {}) {
  switch (action.type) {
    case `${CREATE_ROHSTOFF}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CREATE_ROHSTOFF}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${CREATE_ROHSTOFF}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function rohstoffDelete(state = initialState, action = {}) {
  switch (action.type) {
    case `${DELETE_ROHSTOFF}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${DELETE_ROHSTOFF}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${DELETE_ROHSTOFF}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function rohstoffUpdate(state = initialState, action = {}) {
  switch (action.type) {
    case `${UPDATE_ROHSTOFF}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${UPDATE_ROHSTOFF}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${UPDATE_ROHSTOFF}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function rohstoffCheckReferences(state = initialState, action = {}) {
  switch (action.type) {
    case `${CHECK_ROHSTOFF_REFERENCES}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CHECK_ROHSTOFF_REFERENCES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : '',
      };
    case `${CHECK_ROHSTOFF_REFERENCES}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

// History reducers
const historyInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: { versions: [], total: 0 },
};

const versionInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: null,
};

const restoreInitialState = {
  error: null,
  loaded: false,
  loading: false,
  success: false,
  data: null,
};

const compareInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: null,
};

export function rohstoffHistory(state = historyInitialState, action = {}) {
  switch (action.type) {
    case `${GET_ROHSTOFF_HISTORY}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_ROHSTOFF_HISTORY}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result')
          ? action.result
          : { versions: [], total: 0 },
      };
    case `${GET_ROHSTOFF_HISTORY}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: { versions: [], total: 0 },
      };
    case RESET_ROHSTOFF_HISTORY:
      return historyInitialState;
    default:
      return state;
  }
}

export function rohstoffVersion(state = versionInitialState, action = {}) {
  switch (action.type) {
    case `${GET_ROHSTOFF_VERSION}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_ROHSTOFF_VERSION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : null,
      };
    case `${GET_ROHSTOFF_VERSION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: null,
      };
    case RESET_ROHSTOFF_HISTORY:
      return versionInitialState;
    default:
      return state;
  }
}

export function rohstoffRestore(state = restoreInitialState, action = {}) {
  switch (action.type) {
    case `${RESTORE_ROHSTOFF_VERSION}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
        success: false,
      };
    case `${RESTORE_ROHSTOFF_VERSION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        success: true,
        data: has(action, 'result') ? action.result : null,
      };
    case `${RESTORE_ROHSTOFF_VERSION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        success: false,
        data: null,
      };
    case RESET_ROHSTOFF_HISTORY:
      return restoreInitialState;
    default:
      return state;
  }
}

export function rohstoffCompare(state = compareInitialState, action = {}) {
  switch (action.type) {
    case `${COMPARE_ROHSTOFF_VERSIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${COMPARE_ROHSTOFF_VERSIONS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : null,
      };
    case `${COMPARE_ROHSTOFF_VERSIONS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: null,
      };
    case RESET_ROHSTOFF_HISTORY:
      return compareInitialState;
    default:
      return state;
  }
}
